import React from 'react';
import classnames from 'classnames';
import { getIntlString } from '@goparrot-dashboard/i18n';
import { Button, IconBurger, IconCloseMedium } from '@goparrot-dashboard/shared-ui';
import './NavBarStyles.css';

interface SquareHeadingButtonProps {
  isSidebarVisibleOnMobile: boolean;
  onClick: (visible: boolean) => void;
}

export const SquareHeading: React.FC<SquareHeadingButtonProps> = ({ isSidebarVisibleOnMobile, onClick }) => {
  return (
    <Button
      color="clean"
      kind="clean"
      data-testid="mobile-logo"
      align="left"
      noFocusOutline
      onClick={() => {
        onClick(!isSidebarVisibleOnMobile);
      }}
      className={classnames(
        'tw-mb-1 tw-relative tw-z-1 tw-bg-white tw-ring-opacity-0',
        'focus:tw-ring-opacity-0 tw-gap-2 tw-h-8 tw-w-8',
        isSidebarVisibleOnMobile ? 'xl:tw-w-[264px]' : 'lg:tw-w-[264px]',
      )}
    >
      {isSidebarVisibleOnMobile ? (
        <>
          <IconCloseMedium className="tw-block xl:tw-hidden" />
          <IconBurger className="xl:tw-block tw-hidden" />
        </>
      ) : (
        <IconBurger />
      )}

      <span
        className={classnames(
          'tw-font-bold tw-text-[19px] tw-hidden tw-whitespace-nowrap  square-sans-display-font',
          isSidebarVisibleOnMobile ? 'xl:tw-block' : 'lg:tw-block',
        )}
      >
        {getIntlString('topbar.squareForFranchises')}
      </span>
    </Button>
  );
};
